import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary, error, text } = theme.palette;

  return {
    examItem: {
      position: "relative",
      marginBottom: 24,
      "&:first-child": {
        marginBottom: 10
      },
      "&.details": {
        minHeight: 580
      }
    },
    cloneExam: {
      borderColor: secondary.dark,
      color: secondary.dark,
      borderRadius: 20,
      height: 40,
      width: 200,
      textTransform: "capitalize",
      display: "flex",
      justifySelf: "center",
      lineHeight: "normal",
      margin: "10px auto"
    },
    cloneExamLabel: {
      flexDirection: "column"
    },
    cloneExamWarning: {
      fontSize: 10,
      color: text.secondary,
      fontStyle: "italic"
    },
    viewMedia: {
      display: "none",
      color: secondary.dark,
      textTransform: "capitalize",
      fontSize: 11,
      padding: "0 8px",
      marginRight: -4,
      "&.Mui-disabled": {
        color: secondary.dark,
        opacity: 0.3
      },
      "&.details": {
        fontSize: 12,
        marginRight: -8
      }
    },
    mediaIcon: {
      fontSize: "14px !important",
      "&.details": {
        position: "relative",
        bottom: 1,
        marginRight: 4
      }
    },
    imageIcon: {
      fontSize: "14px !important",
      "&.details": {
        fontSize: "20px !important"
      }
    },
    decisionValue: {
      display: "flex",
      alignItems: "flex-end"
    },
    decisionIcon: {
      fontSize: 20,
      margin: "0 -3px 0 4px"
    },
    doneIcon: {
      color: secondary.dark
    },
    failIcon: {
      color: error.main
    },
    examDetails: {
      backgroundColor: "#f6f6f6",
      borderLeft: "1px solid #ddd",
      borderRight: "1px solid #ddd",
      "&.details": {
        borderLeft: "none",
        borderRight: "none"
      }
    },
    row: {
      display: "flex",
      alignItems: "flex-end",
      fontSize: 12,
      padding: "6px 10px",
      minHeight: 34,
      borderBottom: "1px solid #ddd",
      "&.details": {
        fontSize: 14,
        padding: "11px 20px 11px 16px"
      }
    },
    mainRow: {
      justifyContent: "space-between",
      paddingRight: 8
    },
    rowName: {
      textTransform: "capitalize",
      maxWidth: "50%"
    },
    subRow: {
      justifyContent: "flex-end",
      textTransform: "uppercase"
    },
    trainerComment: {
      backgroundColor: "#f6f6f6"
    },
    loader: {
      minHeight: 475,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&.details": {
        position: "absolute",
        opacity: 0.7,
        minHeight: "100%",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: 1
      }
    }
  };
});
